import { createFileRoute, Outlet } from "@tanstack/react-router";

import { ArtifactPanel } from "@/components/chat/ArtifactPanel";

export const Route = createFileRoute("/_authenticated/chat")({
  component: ChatLayout,
});

// Onboarding is no longer a modal. It happens inside the agent conversation
// (onboarding-v2 §3.6), so this layout mounts nothing but the chat itself.
function ChatLayout() {
  return (
    <>
      <Outlet />
      <ArtifactPanel />
    </>
  );
}
